/**
 * Health API - Auto-generated typed wrapper.
 * DO NOT EDIT - Regenerate with: bun run generate
 * @generated
 */

import { healthCheck, livenessCheck, readinessCheck } from "../generated/health/health";

import { wrapMethod } from "./utils";

export const health = {
  /** @see livenessCheck */
  livenessCheck: wrapMethod(livenessCheck),

  /** @see readinessCheck */
  readinessCheck: wrapMethod(readinessCheck),

  /** @see healthCheck */
  healthCheck: wrapMethod(healthCheck),
} as const;

export type HealthApi = typeof health;
